"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerPageBookingEdit = void 0;
const firestore_1 = require("firebase/firestore");
const react_1 = __importStar(require("react"));
const Alert_1 = __importDefault(require("react-bootstrap/Alert"));
const Container_1 = __importDefault(require("react-bootstrap/Container"));
const react_router_dom_1 = require("react-router-dom");
const configContext_1 = require("../../context/configContext");
const bookingFactory = __importStar(require("../../models/helper/bookingFactory"));
const useFirestore_1 = require("../../utils/useFirestore");
const BookingEditor_1 = require("../booking-editor/BookingEditor");
const Spinner_1 = require("../spinner/Spinner");
/**
 * Opens the booking editor to edit an existing booking.
 */
const ManagerPageBookingEdit = (props) => {
    const { bookingReference } = (0, react_router_dom_1.useParams)();
    const config = (0, configContext_1.useConfig)();
    const firestore = (0, useFirestore_1.useFirestore)();
    const [booking, setBooking] = (0, react_1.useState)();
    const [notFound, setNotFound] = (0, react_1.useState)(false);
    // Load Booking from db or create a new booking.
    (0, react_1.useEffect)(() => {
        const abortController = new AbortController();
        async function loadBooking() {
            try {
                const bookingSnapshot = await (0, firestore_1.getDocs)((0, firestore_1.query)((0, firestore_1.collection)(firestore, "bookings"), (0, firestore_1.where)("tenantId", "==", config.tenantId), (0, firestore_1.where)("reference", "==", bookingReference)));
                if (bookingSnapshot.size === 1) {
                    const loadedBooking = bookingFactory.createFromFirestore(bookingSnapshot.docs[0], config);
                    setBooking(loadedBooking);
                }
                else {
                    setNotFound(true);
                }
            }
            catch (error) {
                if (!abortController.signal.aborted) {
                    throw error;
                }
            }
        }
        loadBooking();
        return () => abortController.abort();
    }, []);
    if (notFound) {
        return (react_1.default.createElement(Container_1.default, { fluid: true },
            react_1.default.createElement(Alert_1.default, { className: "mt-3", variant: "danger" },
                "Buchung nicht gefunden: reference=",
                bookingReference)));
    }
    else if (!booking) {
        return react_1.default.createElement(Spinner_1.Spinner, { className: "my-3 mx-auto" });
    }
    else {
        return react_1.default.createElement(BookingEditor_1.BookingEditor, { booking: booking });
    }
};
exports.ManagerPageBookingEdit = ManagerPageBookingEdit;
